import type { MouseEvent } from "react";

import { StyledModalText, UIButton } from "common/components";
import { useDispatch } from "common/utilities/react-redux";
import { useGo } from "common/utilities/useGo";
import { useTranslate } from "common/utilities/useTranslate";
import { deactivateModal } from "domains/modal/actions";
import { ModalHeader } from "domains/modal/components/ModalHeader";

export const CollectionCancellationConfirmationModal = () => {
  const dispatch = useDispatch();
  const go = useGo();
  const translate = useTranslate();

  const route = "/create?mode=collection";

  const onClick = (event: MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    dispatch(deactivateModal());
    go(route);
  };

  return (
    <>
      <ModalHeader title={translate("app.create.collection.modal.cancellation.title")} />
      <StyledModalText>{translate("app.create.collection.modal.cancellation.text")}</StyledModalText>
      <UIButton as="a" error fullwidth href={route} onClick={onClick}>
        {translate("app.create.collection.modal.cancellation.confirm")}
      </UIButton>
    </>
  );
};
